import { IDisclaimers } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

// Custom fetch
export interface ICustomDisclaimerState extends IStateStrict<IDisclaimers> {
  singleWithKey: IDisclaimers | null;
}
// Base store configuration
const adminGatewayResourcePath: string = '/syndication-api/disclaimers';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IDisclaimers>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'disclaimers/'

  state: {
    ...base.state,
    singleWithKey: null,
  },

  getters: {
    ...base.getters,
    singleWithKey: (state: ICustomDisclaimerState) => state.singleWithKey,
  },

  mutations: {
    ...base.mutations,
    setSingleWithKey: (state: ICustomDisclaimerState, payload: IDisclaimers) => {
      state.singleWithKey = payload;
    },
  },

  actions: {
    ...base.actions,

    getDisclaimerByKey: async (
      ctx: IAction<ICustomDisclaimerState>,
      key: string,
    ) => {
      const response = (await adminRequest.get(
        `/syndication-api/disclaimers?where=key:${key}`,
      )).data[0];

      ctx.commit('setSingleWithKey', response);
    },
  },
};
